
























































































import { ciExternalLink } from '~/icons/source/regular/external-link'
import { defineComponent } from '@nuxtjs/composition-api'
import { mapGetters } from 'vuex'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { defineVue3AsyncComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    CImageViewer: defineVue3AsyncComponent(() =>
      import('~/components/shared/configurable/image/CImageViewer.vue')
    )
  },
  props: {
    attachments: { type: Array, required: true },
    inMessage: { type: Boolean, required: false, default: false },
    messageMine: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      allowedImages: ['image/jpeg', 'image/jpg', 'image/png'],
      icons: {
        link: ciExternalLink
      },
      selectedIndex: 0,
      showZoomer: false
    }
  },
  computed: {
    ...mapGetters(USER_AGENT_NS, {
      isPc: 'isPc'
    }),
    imagesInAttachments() {
      return this.attachments
        .filter(a => this.isImage(a))
        .map(a => {
          return {
            type: 'image',
            url: this.imageLink(a),
            name: null
          }
        })
    },
    isIframe() {
      if (window.frameElement) {
        return true
      }
      return false
    }
  },
  methods: {
    isImage(attachment) {
      if (attachment.content_type) {
        return this.allowedImages.includes(attachment.content_type)
      }

      return attachment.type && attachment.type === 'image'
    },
    isGiphy(attachment) {
      return attachment.content_type === 'giphy'
    },
    isLocal(attachment) {
      if (attachment.domain && attachment.file) {
        return false
      }

      return true
    },
    attachmentClicked(attachment) {
      if (this.isImage(attachment) && !this.isIframe) {
        const indx = this.getImageIndex(attachment)
        this.selectedIndex = indx
        this.showZoomer = true
      }
    },
    getImageIndex(attachment) {
      for (let i = 0; i < this.imagesInAttachments.length; i++) {
        if (this.imagesInAttachments[i].url === this.imageLink(attachment)) {
          return i
        }
      }
      return null
    },
    imageLink(attachment) {
      if (attachment.domain && attachment.file) {
        return attachment.domain + attachment.file
      } else if (attachment.thumb) {
        return attachment.thumb
      }

      return ''
    },
    displayTag(tagsArray) {
      for (let i = 0; i < tagsArray.length; i++) {
        if (tagsArray[i] === 'resume') {
          return this.$t('resume')
        }
      }
      return null
    }
  }
})
